<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-05">‘All the future is foretold, but freedom of choice is given to everyone.’</p>
<p class="fm-06"><span>Rabbi Akiba ben Joseph</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter03.vue?01e15957